import React from "react";
import { Modal } from "react-bootstrap";
import ModalFormProducto from "./ModalFormProducto";

const ModalProducto = ({ show, handleClose, producto }) => {
  console.log(producto);

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Modificar Producto</Modal.Title>
      </Modal.Header>

      <ModalFormProducto producto={producto} handleClose={handleClose} />
    </Modal>
  );
};

export default ModalProducto;